<script>
// Extensions
import View from "@/views/View";

// Mixins
import LoadSections from "@/mixins/load-sections";

export default {
  name: "KalkulatorKontribusiBank",

  metaInfo: { title: "Kalkulator Kontribusi" },

  extends: View,

  mixins: [LoadSections(["CalculatorBank", "info"])],

  props: {
    id: {
      type: String,
      default: "calculatorbank"
    }
  }
};
</script>
